<template>
  <div class="page-container">
    <searchable-grid title="Early Bird Enrollments" :column-defs="columnDefs" :get-rows-promise="getRows" @cellDoubleClicked="onCellDoubleClicked"></searchable-grid>
  </div>
</template>

<script>
import api from '@/api';
import SearchableGrid from '@/components/grid/SearchableGrid.vue';

export default {
  data() {
    return {
      columnDefs: [
        {
          headerName: 'Client',
          field: 'clientName',
          cellRenderer: (params) => {
            if (params.value !== undefined) {
              return params.value;
            }
            return '<i class="el-icon-loading"></i>';
          },
        },
        {
          headerName: 'Redemption Type',
          field: 'typeName',
        },
        {
          headerName: 'Date Enrolled',
          field: 'dateAdded',
          filter: 'date',
        },
      ],
    };
  },
  methods: {
    getRows(params) {
      return api.ebEnrollment.getGridData(params);
    },
    onCellDoubleClicked(event) {
      if (event.data && event.data.clientId) {
        this.$router.push({ name: 'clientDetail', params: { id: event.data.clientId } });
      }
    },
  },
  components: {
    SearchableGrid,
  },
};

</script>

<style lang="scss" scoped>

</style>
